export default "__VITE_ASSET__354b888d__"